import { createRoot, hydrateRoot } from 'react-dom/client'
import client from '@based/sdk/client'
import basedConfig from '../../based'
import App from './App'
import 'modern-normalize'
import 'leaflet/dist/leaflet.css'
import 'maplibre-gl/dist/maplibre-gl.css'
import './index.css'
import './body.css'

const based = client(basedConfig)

if (typeof window !== 'undefined') {
  const rootElement = document.getElementById('root')
  if (rootElement) {
    // Pass the current URL path + search to ensure hydration consistency
    // wouter's useSyncExternalStore uses this as the "server snapshot" during hydration
    const ssrPath = window.location.pathname + window.location.search

    if (rootElement.hasChildNodes()) {
      hydrateRoot(rootElement, <App basedClient={based} ssrPath={ssrPath} />)
    } else {
      const root = createRoot(rootElement)
      root.render(<App basedClient={based} />)
    }
  }
}
